/* FITNES.LAT — scripts propios (prefijo fl-) */

function flInitReveal() {
  const els = document.querySelectorAll('.fl-reveal, .fl-reveal-scale');
  if (!els.length) return;

  function revealNow(el) {
    el.classList.add('fl-visible');
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(revealNow);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealNow(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  els.forEach((el, i) => {
    el.style.transitionDelay = `${Math.min(i % 4, 3) * 90}ms`;
    const rect = el.getBoundingClientRect();
    const alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (alreadyVisible) {
      revealNow(el);
    } else {
      observer.observe(el);
    }
  });

  // Salvaguarda: si por lo que sea el navegador nunca dispara el observador
  // (pestaña en segundo plano, entorno atípico...), el contenido no debe
  // quedar invisible para siempre.
  setTimeout(() => {
    els.forEach(revealNow);
    observer.disconnect();
  }, 3000);
}

function flInitFaq() {
  document.querySelectorAll('.fl-faq__item').forEach((item) => {
    const btn = item.querySelector('.fl-faq__pregunta');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const wasOpen = item.classList.contains('fl-open');
      item.closest('.fl-faq__list')?.querySelectorAll('.fl-faq__item').forEach((i) => i.classList.remove('fl-open'));
      if (!wasOpen) item.classList.add('fl-open');
    });
  });
}

function flInitGaleria() {
  document.querySelectorAll('[data-fl-galeria]').forEach((galeria) => {
    const principal = galeria.querySelector('[data-fl-imagen-principal]');
    const videoPrincipal = galeria.querySelector('[data-fl-video-principal]');
    if (!principal) return;
    galeria.querySelectorAll('[data-fl-miniatura]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const videoSrc = thumb.getAttribute('data-video');
        const imgSrc = thumb.getAttribute('data-full');
        if (videoSrc && videoPrincipal) {
          videoPrincipal.src = videoSrc;
          videoPrincipal.style.display = 'block';
          principal.style.display = 'none';
          videoPrincipal.play().catch(() => {});
        } else if (imgSrc) {
          if (videoPrincipal) {
            videoPrincipal.pause();
            videoPrincipal.style.display = 'none';
          }
          principal.style.display = 'block';
          principal.src = imgSrc;
        }
        galeria.querySelectorAll('[data-fl-miniatura]').forEach((t) => t.classList.remove('fl-activa'));
        thumb.classList.add('fl-activa');
      });
    });
  });
}

function flInitCantidad() {
  document.querySelectorAll('[data-fl-cantidad]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.getAttribute('data-dir') === 'menos' ? -1 : 1;
        const current = parseInt(input.value, 10) || 1;
        const next = Math.max(1, current + dir);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

function flInitVariantes() {
  document.querySelectorAll('[data-fl-producto]').forEach((wrap) => {
    const dataEl = wrap.querySelector('[data-fl-variantes-json]');
    const idInput = wrap.querySelector('[data-fl-variant-id]');
    const priceEl = wrap.querySelector('[data-fl-precio]');
    const compareEl = wrap.querySelector('[data-fl-precio-comparado]');
    const submitBtn = wrap.querySelector('[data-fl-submit]');
    if (!dataEl || !idInput) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function findVariant() {
      const selected = {};
      wrap.querySelectorAll('[data-fl-opcion]').forEach((optWrap) => {
        const name = optWrap.getAttribute('data-fl-opcion');
        const active = optWrap.querySelector('.fl-activa');
        if (active) selected[name] = active.getAttribute('data-value');
      });
      return variants.find((v) => v.options.every((val, i) => selected[v.optionNames[i]] === val));
    }

    function updateUI(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        if (variant.compare_at_price) {
          compareEl.textContent = variant.compare_at_price;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? submitBtn.getAttribute('data-label-disponible')
          : submitBtn.getAttribute('data-label-agotado');
      }
    }

    wrap.querySelectorAll('[data-fl-opcion]').forEach((optWrap) => {
      optWrap.querySelectorAll('[data-value]').forEach((pill) => {
        pill.addEventListener('click', () => {
          if (pill.disabled) return;
          optWrap.querySelectorAll('[data-value]').forEach((p) => p.classList.remove('fl-activa'));
          pill.classList.add('fl-activa');
          updateUI(findVariant());
        });
      });
    });
  });
}

function flInitMarquee() {
  document.querySelectorAll('[data-fl-marquee]').forEach((track) => {
    if (track.dataset.flCloned) return;
    track.dataset.flCloned = 'true';
    const clone = track.innerHTML;
    track.insertAdjacentHTML('beforeend', clone);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  flInitReveal();
  flInitFaq();
  flInitGaleria();
  flInitCantidad();
  flInitVariantes();
  flInitMarquee();
});
